export const magicNumbersForStyling = {
  rowHeight: '50px',
  nameCellWidth: '1fr',
  columnWidth: '120px',
  narrowColumnWidth: '60px',
  wideColumnWidth: '180px',
  numberColumnWidth: '30px',
  toColumnWidth: '30px',
  payeeColumnWidth: '1fr',
};
